export default __webpack_public_path__ + "static/media/bok.2d7c33b8.svg";